module.exports = __webpack_public_path__ + "img/Server3.f2eec29.svg";